import React from 'react';
import { ActionMeta, OnChangeValue } from 'react-select-v5';

import { getMetaError } from 'shared/functions/errors';
import { getClassNames } from 'shared/functions/utils';
import { SelectV5 } from 'shared/ui/SelectV5/SelectV5';
import { SelectProps } from 'shared/ui/SelectV5/SelectV5Types';

type Props = {
  input: {
    name: string;
    value: any;
    onChange?: (newValue: OnChangeValue<any, false>, actionMeta: ActionMeta<any>) => void;
  };
  meta?: ActionMeta<any>;
  label?: string;
  isFixedOption?: boolean;
  prefix?: string;
  postfix?: string;
  valueClass?: string;
  formClass?: string;
  labelClass?: string;
  valueKey: string;
  labelKey: string;
} & SelectProps<any>;
export const SelectField: React.FC<Props> = ({ input, meta, label, isFixedOption, ...rest }) => {
  const error = getMetaError(meta);

  return (
    <div id={`${input.name}-wrapper`} data-testid={input.name} className={getClassNames('form-group', rest.formClass)}>
      {label && <label className={getClassNames('control-label', rest.labelClass)}>{label}</label>}
      <div className={getClassNames(rest.valueClass, (rest.prefix || rest.postfix) && 'input-group')}>
        <SelectV5
          className="Select"
          classNamePrefix="Select-control"
          {...rest}
          valueKey="value"
          labelKey="label"
          onChange={input.onChange}
          value={input.value}
        />
      </div>
      {error && <div className="errorMsg">{error}</div>}
    </div>
  );
};
